const {validate} = require("validate.js");

const validFileExtensions = ["pdf"]
const maxCurriculumFileSize = 2000000;  //max: 2mb

function hasValidFileExt(fileName){
    let ext = fileName.indexOf(".") > -1 ? fileName.split(".").pop() : null;
    return validFileExtensions.indexOf(ext) > -1;
}

const constraints = {
    name: {
        presence: true,
        format: /^(\w|\s){1,30}/
    },
    phone: {
        presence: true,
        format: /^(\+|-|\d|\s|\(|\)){6,20}/
    },
    description: {
        presence: false,
        length: {
            maximum: 300
        }
    },
    curriculum: {
        format: {
            pattern: /^(\+|-|\d|\s|\(|\)){6,20}/,
            message: function(value, attributes, attributeName, options, constraints) {
                if(value && !hasValidFileExt(value)){
                    return validate.format(`Has invalid file extension (Only allowed ${validFileExtensions.join(", ")})`);
                }
            }
        }
    },
    email: {
        presence: true,
        format: {
            pattern: /^.{1,50}$/
        }
    }
}

module.exports.Validator = class Validator {
    static validateCareersContact(formData){
        /**
         * 
         *  name
            email
            phone
            curriculum
            description
         */
        return validate(formData, {
            name: constraints.name,
            phone: constraints.phone,
            description: constraints.description,
            curriculum: constraints.curriculum,
            email: constraints.email
        });
    }


    static validateContactForm(formData){
        /**
         * 
         *  name
            email
            phone
            curriculum
            description
         */
        const validation = validate(formData, {
            name: constraints.name,
            phone: constraints.phone,
            description: constraints.description,
            email: constraints.email
        });
        //console.log({validation});
        return validation;
    }


    static validateContactPageForm(formData){
        /**
         * 
         *  name
            email
            phone
            curriculum
            description
         */
        const validation = validate(formData, {
            name: constraints.name,
            description: constraints.description,
            email: constraints.email
        });
        return validation;
    }

    static hasValidFileExt = hasValidFileExt;

    static hasValidCurriculumSize(sizeInBytes){
        return sizeInBytes < maxCurriculumFileSize;   //Lesser than 2mb
    }

    static get curriculumFileSize(){
        return maxCurriculumFileSize;
    }
}